import {Injectable} from '@angular/core';
import {QueryEntity} from '@datorama/akita';
import {TransporterState, Store} from './store';

@Injectable({ providedIn: 'root' })
export class TransporterQuery extends QueryEntity<TransporterState> {

  constructor(protected store: Store) {
    super(store);
  }

}
